/**
 * Fence-section colour texture: the stations x depth-levels grid of a 2D model, coloured with the model colour table
 * (lib/model-colour). Shared by the flat FencePlane and the DEM-draped fence. Pure.
 */
import { colourTexturePixels } from './model-colour';

/** { w, h, values } resistivities per texel; texture row 0 = the deepest level. Texels below the DOI (`belowDoi(cell)`) or without a cell stay 0. */
export function fenceGrid(cells, belowDoi) {
  const xs = [...new Set(cells.map((c) => c.x))].sort((a, b) => a - b);
  const ds = [...new Set(cells.map((c) => c.depth))].sort((a, b) => a - b);
  const w = Math.max(2, xs.length), h = Math.max(2, ds.length);
  const xi = new Map(xs.map((x, i) => [x, i]));
  const di = new Map(ds.map((d, i) => [d, i]));
  const values = new Float64Array(w * h);
  cells.forEach((c) => {
    const ix = xi.get(c.x), iy = di.get(c.depth);
    if (ix === undefined || iy === undefined || !(c.resistivity > 0) || (belowDoi && belowDoi(c))) return;
    values[(h - 1 - iy) * w + ix] = c.resistivity;
  });
  return { w, h, values };
}

/** { w, h, data } RGBA texels of a fence section coloured with `scale` (makeColourScale). */
export function fencePixels(cells, scale, belowDoi) {
  const { w, h, values } = fenceGrid(cells, belowDoi);
  return { w, h, data: colourTexturePixels(values, w, h, scale) };
}
